<footer class="footer-logos">
    @if (branding) {
    <div class="logo-box logo-leonardo">
        <img src="assets/Leonardo copia.png" alt="Leonardo">
    </div>
    <div class="logo-box">
        <img src="assets/Almaviva.png" alt="Almaviva">
    </div>
    <div class="loghiSmall">
        <div class="logo-box logo-small tim">
            <img src="assets/TIM.png" alt="TIM">
        </div>
        <div class="logo-box logo-small cae">
            <img src="assets/caeLogo.png" alt="CAE">
        </div>
    </div>
    } @else {
    <span class="logo-placeholder">Lorem ipsum</span>
    <span class="logo-placeholder">Dolor sit</span>
    <span class="logo-placeholder">Amet</span>
    <span class="logo-placeholder">Consectetur</span>
    }
</footer>